const DocumentsRoutes = [
    {
      path: "/documents",
      name: "Documents",
      component: () => import("@/pages/document/DocumentListPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'read', on: 'Document'
        }
      }
    },
  ]
  
  export default DocumentsRoutes